import { auth0Config } from "@/configs/auth-config";
import { formatRangeDate } from "@/helper/date-time";
import { PaymentMethodDistribution } from "@/types/payment-history.type";
import { Constants } from "@/services/web/api.const";
import { addQueryParametersToUrl } from "@/helper/query-params/add-query-params-to-url.util";
import { READ_ORDERS_SCOPE } from "@/modules/finance/helper/constants/api-payment-history.const";
import { useApi } from "@/services/web/use-api";

export const usePaymentMethodsDistribution = (cityId: string | undefined | null, startDate: Date, endDate: Date) => {
  const { startDate: start_date, endDate: end_date } = formatRangeDate(startDate, endDate);

  let params: Record<string, unknown> = {
    start_date,
    end_date,
  };

  if (cityId) {
    params = {
      ...params,
      cityId,
    };
  }

  let url = `${Constants.CLIENTS_API_URL}/orders/payment-methods`;
  url = addQueryParametersToUrl(url, params);
  const {
    isLoading: loading,
    error,
    data,
  } = useApi<PaymentMethodDistribution[]>(
    url,
    {
      method: "GET",
      audience: auth0Config.clientAudiance,
      scope: READ_ORDERS_SCOPE,
    },
    undefined,
  );

  return {
    loading,
    error,
    data,
  };
};
